import $ from 'jquery'

export default {

  enable () {
    
    $('.load-screen').fadeTo( "medium" , 0, () => {
      $('.load-screen').remove()
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/elements/load-screen.js